(()=>{
 const section=document.getElementById('hkgship-import-details');if(!section)return;
 const params=new URLSearchParams(location.search);
 if(!(params.get('direction')==='import'&&params.get('step')==='details'))return;
 section.hidden=false;document.body.classList.add('hkg-import-view');
 const root=document.querySelector('[data-import-back]').getAttribute('href').split('?')[0];
 const back=new URLSearchParams({direction:'import',origin:params.get('origin')||''});
 section.querySelector('[data-import-back]').href=root+'?'+back+'#hkgship-quote';
 const form=section.querySelector('form'),field=name=>form.querySelector('[data-field="'+name+'"]');
 const strings=JSON.parse(section.querySelector('[data-import-strings]').textContent);
 const data=window.HKGImportRates,origin=params.get('origin'),language=JSON.parse(section.querySelector('[data-import-config]').textContent);
 const selector=document.querySelector('select[id^="HkgOrigin-"]');
 const option=selector&&[...selector.options].find(x=>x.value===origin);
 const country=option?.textContent.trim()||origin;
 if(!data?.origins[origin]||!Number.isFinite(Number(params.get('weight')))||Number(params.get('weight'))<=0){
  section.querySelector('[data-quote-error]').hidden=false;section.querySelector('[data-import-fields]').hidden=true;return;
 }
 field('Origin country').value=country+' ('+origin+')';
 field('Pickup postcode').value=params.get('postal_code')||'';
 field('Pickup postcode').required=['CN','US'].includes(origin);
 const initial=window.HKGImportPricing.quote(data,{origin,postalCode:params.get('postal_code'),weight:params.get('weight')});
 const quoted=initial.status==='ok'?'HKD '+initial.price.toLocaleString('en-HK'):strings.manual;
 section.querySelector('[data-quote-price]').textContent=quoted;
 section.querySelector('[data-route]').textContent=country+' → '+(language.startsWith('zh')?'香港':'Hong Kong')+' · '+params.get('weight')+' kg';
 section.querySelector('[data-initial-quote]').value=quoted+'; entered weight '+params.get('weight')+' kg; postcode '+(params.get('postal_code')||'');
 section.querySelector('[data-validity]').value=data.validFrom+' — '+data.validTo+'; standard fuel '+data.fuelPercent+'%';
 
 const phone=field('Sender phone'),whatsapp=field('WhatsApp'),same=section.querySelector('[data-same-phone]'),method=field('Label delivery');
 function international(input){
  const value=input.value.trim();input.setCustomValidity(value&&!/^\+[1-9][\d\s().-]{6,20}$/.test(value)?strings.invalid_phone:'');
 }
 function syncWhatsApp(){
  whatsapp.required=method.value!=='Email';
  if(same.checked)whatsapp.value=phone.value;
  whatsapp.readOnly=same.checked;
  international(whatsapp);
 }
 [phone,whatsapp].forEach(input=>input.addEventListener('input',()=>{international(input);if(input===phone)syncWhatsApp();}));
 same.addEventListener('change',syncWhatsApp);method.addEventListener('change',syncWhatsApp);syncWhatsApp();
 const count=field('Number of packages'),boxes=section.querySelector('[data-boxes]'),template=section.querySelector('[data-box-template]');
 let removed=[];
 function renderBoxes(){
  const number=Number(count.value);if(!Number.isInteger(number)||number<1||number>99)return;
  while(boxes.children.length>number){removed[boxes.children.length-1]=boxes.lastElementChild;boxes.lastElementChild.remove();}
  while(boxes.children.length<number){
   const index=boxes.children.length;
   const node=removed[index]||template.content.firstElementChild.cloneNode(true);
   node.querySelector('[data-box-title]').textContent=strings.box.replace('__NUMBER__',String(index+1));
   node.querySelectorAll('[data-box-field]').forEach(input=>input.name='properties[_Package '+(index+1)+' '+input.dataset.boxField+']');
   boxes.append(node);
  }
  updateBoxes();
 }
 function packageData(){
  return [...boxes.children].map((box,index)=>({package:index+1,...Object.fromEntries([...box.querySelectorAll('[data-box-field]')].map(input=>[input.dataset.boxField,input.value]))}));
 }
 function updateBoxes(){
  const packages=packageData(),complete=packages.every(p=>['weight','length','width','height'].every(key=>Number(p[key])>0));
  const total=packages.reduce((sum,p)=>sum+Math.max(Number(p.weight)||0,(Number(p.length)||0)*(Number(p.width)||0)*(Number(p.height)||0)/5000),0);
  section.querySelector('[data-box-details]').value=JSON.stringify(packages);
  section.querySelector('[data-box-total]').textContent=complete?strings.box_total.replace('__WEIGHT__',String(Math.round(total*100)/100)):'';
  const revised=complete?window.HKGImportPricing.quote(data,{origin,postalCode:field('Pickup postcode').value,weight:total}):initial;
  const revisedText=revised.status==='ok'?'HKD '+revised.price.toLocaleString('en-HK'):strings.manual;
  section.querySelector('[data-quote-price]').textContent=revisedText;
  section.querySelector('[data-route]').textContent=country+' → '+(language.startsWith('zh')?'香港':'Hong Kong')+' · '+(complete?Math.round(total*100)/100:params.get('weight'))+' kg';
  section.querySelector('[data-revised-quote]').value=revisedText+'; '+(complete?'package chargeable total '+total:'initial entered weight '+params.get('weight'))+' kg; current postcode '+field('Pickup postcode').value+'; subject to review';
 }
 count.addEventListener('change',renderBoxes);boxes.addEventListener('input',updateBoxes);renderBoxes();
 field('Pickup postcode').addEventListener('input',updateBoxes);
 const date=field('Preferred pickup date');
 const earliest=new Date(Date.now()-86400000).toISOString().slice(0,10);date.min=earliest;

 const button=section.querySelector('[data-submit]'),error=section.querySelector('[data-import-error]');
 const checkoutRoot=root.replace(/\/$/,'')+'/';
 let pending=false;button.disabled=false;
 async function cartRequest(path,body){
  const response=await fetch(checkoutRoot+path,{method:body?'POST':'GET',headers:body?{'Content-Type':'application/json'}:{},body:body?JSON.stringify(body):undefined});
  if(!response.ok)throw new Error(strings.error);
  return response.json();
 }
 form.addEventListener('submit',async event=>{
  event.preventDefault();
  if(pending)return;
  syncWhatsApp();[phone,whatsapp].forEach(international);
  if(!form.reportValidity())return;
  updateBoxes();
  const properties=Object.fromEntries([...form.querySelectorAll('[name^="properties["]')].filter(input=>input.type!=='checkbox'||input.checked).map(input=>[input.name.slice(11,-1),input.value]));
  properties['_Shipment direction']='Import to Hong Kong';
  properties['_Origin code']=origin;
  properties['_Destination']='Hong Kong';
  properties['_Handover method']='Overseas door pickup';
  properties['_Customer name']=field('name').value;
  properties['_Customer email']=field('email').value;
  properties['_Customer phone']=field('Sender phone').value;
  properties['_Estimated shipping fee']=section.querySelector('[data-quote-price]').textContent;
  properties['_Estimated weight']=section.querySelector('[data-route]').textContent.split(' · ').pop();
  properties['_body']='';
  const tokenKey='hkg-import-registration:'+origin;
  let token=sessionStorage.getItem(tokenKey);
  if(!token){token=crypto.randomUUID();sessionStorage.setItem(tokenKey,token);}
  properties['_Registration token']=token;
  pending=true;button.disabled=true;error.hidden=true;
  const label=button.firstElementChild,labelText=label.textContent;label.textContent=strings.busy;
  try{
   const cart=await cartRequest('cart.js');
   if(cart.items.some(item=>item.final_line_price!==0||item.requires_shipping||item.handle!=='hkgship-import-registration'))throw new Error(strings.cart_conflict);
   const prior=cart.items.find(item=>item.properties?.['_Registration token']===token&&String(item.variant_id)==='67627596415221');
   if(prior){
    await cartRequest('cart/change.js',{id:prior.key,quantity:1,properties});
   }else{
    await cartRequest('cart/add.js',{items:[{id:67627596415221,quantity:1,properties}]});
   }
   const updated=await cartRequest('cart.js');
   if(updated.total_price!==0||updated.items.some(item=>item.requires_shipping))throw new Error(strings.cart_conflict);
   location.assign(checkoutRoot+'checkout');
  }catch(e){
   error.textContent=e.message||strings.error;error.hidden=false;
   error.setAttribute('tabindex','-1');error.focus();
   pending=false;button.disabled=false;label.textContent=labelText;
  }
 });
})();
